import { render, staticRenderFns } from "./UserSettingsView.vue?vue&type=template&id=5676215f&scoped=true&xmlns%3Av-touch=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml"
import script from "./UserSettingsView.vue?vue&type=script&lang=js"
export * from "./UserSettingsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5676215f",
  null
  
)

export default component.exports